import { render, staticRenderFns } from "./catFile.vue?vue&type=template&id=568879f0&scoped=true"
import script from "./catFile.vue?vue&type=script&lang=js"
export * from "./catFile.vue?vue&type=script&lang=js"
import style0 from "./catFile.vue?vue&type=style&index=0&id=568879f0&prod&lang=less&scoped=true"
import style1 from "./catFile.vue?vue&type=style&index=1&id=568879f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568879f0",
  null
  
)

export default component.exports